// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconMusd } from "../../../icons/mono/build/icon-musd.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const MusdIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconMusd.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  MusdIcon.displayName = 'MusdIcon';
}

export default MusdIcon;